import './Main.scss';

// load svg sprite
// "touch" each sprite SVG file to trigger webpack processing
function requireAllSvgs(context) {
    context.keys().forEach(context);
}
requireAllSvgs(require.context('../../Public/Assets/Sprite', true, /\.svg$/));

import 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Variables/createNamespace';
import { domReady } from 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Helper';

import '../Fusion/Component/Header';
import '../Fusion/Component/Hamburger';
import '../Fusion/Component/Hamburger';
import '../Fusion/Component/Form';
import '../Fusion/Content/PressGallery';
import '../Fusion/Content/Packages';
import '../Fusion/Content/Video/Video';
import '../Fusion/Content/Video/VideoGallery';
import '../Fusion/Content/Video/MobileVideoGallery';
import '../Fusion/Content/Coach';
import '../Fusion/Content/LicencePackages';

domReady(function() {
    _gg.onReadyRun();
});

function handleCardClicks() {
    const cards = document.querySelectorAll('.text-with-image--link');
    cards.forEach(card => {
        card.addEventListener('click', () => {
            const link = card.querySelector('a.text-with-image__headline');
            if (link) {
                link.click();
            }
        });
    });
}

handleCardClicks();
